import { DEVICE_WIDTH, IMAGE_COLLECTION } from '@blade/common-ui/map-old/2d/src/config/mapConfig';
import { getImgByType, convertLocation, heatMapColor, heatMapColorTransparent } from '@blade/common-ui/map-old/2d/src/utils/tools';
import { v4 as uuidv4 } from 'uuid';
export const uuid = () => {
    return uuidv4();
};
export const creatLayerId = (id) => {
    return 'layerId_' + (id || uuid());
};
export const creatCollectionId = (collectionType, id) => {
    return collectionType + '_collectionId_' + (id || uuid());
};
export const creatCollectionChildId = (collectionType, id) => {
    return collectionType + '_child_' + (id || uuid());
};
export const generateCollectionItemImgData = (collectionItem, imageSize, collectionType) => {
    const vertices = collectionItem?.vertices ?? { x: 0, y: 0 };
    const id = collectionItem?.id ?? '';
    const isDevice = collectionItem?.isDevice ?? false;
    let imageUrl = collectionItem?.imageUrl ?? '';
    const imageType = collectionItem?.imageType ?? collectionItem?.type ?? '';
    let imageHoverUrl = collectionItem?.imageHoverUrl ?? '';
    const imageHoverType = collectionItem?.imageHoverType ?? '';
    const eventType = collectionItem?.eventType ?? '';
    const name = collectionItem?.name ?? '';
    const width = collectionItem?.width ?? DEVICE_WIDTH;
    const height = collectionItem?.height ?? DEVICE_WIDTH;
    const visible = collectionItem?.visible ?? true;
    const opacity = collectionItem?.opacity ?? 1;
    const zIndex = collectionItem?.zIndex ?? 2;
    const dataSymbol = collectionItem?.dataSymbol ?? '';
    const taskId = collectionItem?.taskId ?? '';
    if (!imageHoverUrl && imageHoverType)
        imageHoverUrl = getImgByType(imageHoverType);
    if (!imageUrl && imageType)
        imageUrl = getImgByType(imageType);
    const url = imageUrl;
    const { x, y } = convertLocation(vertices.x, vertices.y, imageSize);
    const propsId = creatCollectionChildId(collectionType, id);
    return {
        props: {
            id: propsId,
            type: 'image',
            name: name,
            visible: visible,
            static: false,
            url: url,
            imageUrl: imageUrl,
            imageHoverUrl: imageHoverUrl,
            width: width,
            height: height,
            transparent: true,
            opacity: opacity,
            position: [x, y, 1],
            zIndex: zIndex,
            interactive: true,
            dataSymbol: dataSymbol,
            isDevice: isDevice,
            eventType: eventType,
            taskId: taskId,
            dataSource: collectionItem,
            collectionType: collectionType,
        }
    };
};
export const generateCollectionImgData = (collection, mapSize) => {
    const name = collection?.name ?? '';
    const children = collection?.children ?? [];
    const visible = collection?.visible ?? true;
    const id = collection?.id ?? '';
    const collectionType = collection?.type ?? '';
    const targetChildren = [];
    children.forEach((i) => {
        targetChildren.push(generateCollectionItemImgData(i, mapSize, collectionType));
    });
    const propsId = creatCollectionChildId(collectionType, id);
    return {
        props: {
            id: propsId,
            type: 'collection',
            name: collectionType,
            visible: visible,
            collectionType: collectionType
        },
        children: targetChildren
    };
};
export const generateCollectionHeatMapData = (collection, mapSize) => {
    const children = collection?.children ?? [];
    const visible = collection?.visible ?? true;
    const collectionType = collection?.type ?? '';
    const targetChildren = [];
    const id = collection?.id ?? '';
    children.forEach((i, index) => {
        targetChildren.push(generateCollectionHeatMapItemData(i, mapSize, collectionType));
    });
    const propsId = creatCollectionId(collectionType, id);
    return {
        props: {
            id: propsId,
            type: 'collection',
            name: collectionType,
            visible: visible,
            collectionType: collectionType
        },
        children: targetChildren
    };
};
export const generateCollectionHeatMapItemData = (collectionItem, mapSize, collectionType) => {
    const { level, points, name } = collectionItem;
    const id = collectionItem?.id ?? '';
    const targetChildren = [];
    const propsId = creatCollectionChildId(collectionType, id);
    points && points.forEach((item) => {
        const { x, y } = convertLocation(item.x, item.y, mapSize);
        targetChildren.push({ x, y, value: 200 });
    });
    return {
        props: {
            id: propsId,
            type: 'heatMap',
            name,
            visible: true,
            interactive: true,
            zIndex: 2,
            radius: 40,
            colorStops: [
                {
                    offset: 0,
                    color: heatMapColor[level],
                },
                {
                    offset: 1,
                    color: heatMapColorTransparent[level],
                }
            ],
            heatMapData: targetChildren
        }
    };
};
const getBackground = (url, width, height, collectionType, id) => {
    const propsId = creatCollectionChildId(collectionType, id);
    return {
        props: {
            id: propsId,
            type: 'image',
            name: 'background-image',
            visible: true,
            zIndex: 1,
            static: true,
            interactive: false,
            url: url,
            width,
            height,
            opacity: 1.0,
            position: [0, 0, 0]
        }
    };
};
export const generateBgcCollectionData = (bgcUrl, bgcSize) => {
    const { width, height } = bgcSize;
    const collectionType = IMAGE_COLLECTION;
    const propsId = creatCollectionId(collectionType);
    return {
        props: {
            id: propsId,
            type: 'collection',
            name: IMAGE_COLLECTION,
            visible: true,
        },
        children: [getBackground(bgcUrl, width, height, collectionType, 0)]
    };
};
export const generateLayerData = (collectionList) => {
    const layerId = creatLayerId();
    return {
        props: {
            id: layerId,
            type: 'layer',
            name: 'layer-root',
            visible: true,
            center: [0, 0],
            zoom: 5,
            minZoom: 1,
            maxZoom: 10,
        },
        children: [...collectionList]
    };
};
// export const updateCollection = (map)
